import { render, staticRenderFns } from "./CompanyOverviewPropertyTable.vue?vue&type=template&id=242a1844&scoped=true&"
import script from "./CompanyOverviewPropertyTable.vue?vue&type=script&lang=js&"
export * from "./CompanyOverviewPropertyTable.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOverviewPropertyTable.vue?vue&type=style&index=0&id=242a1844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a1844",
  null
  
)

export default component.exports